import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { X } from 'react-feather';
import { FormattedMessage } from 'react-intl';

import {
  ModalOverlay,
  ModalContainer,
  ModalContents,
  CloseButton,
  CloseText,
  ModalTopRow,
  ModalBottomRow,
  ModalHeading,
  ModalSubtitle
} from './Modal.styles';

const ESCAPE_KEY_CODE = 27;

const noop = (e) => e.stopPropagation();

const Modal = ({ alert, isOpen, bottomRow, onClose, children, title, subtitle, className, minWidth }) => {
  useEffect(() => {
    if (!isOpen || !onClose) {
      return undefined;
    }

    const listener = window.addEventListener('keyup', (e) => {
      if (e.keyCode === ESCAPE_KEY_CODE) {
        onClose();
      }
    });

    return () => {
      window.removeEventListener('keyup', listener);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <ModalOverlay onClick={onClose} className={className} data-testid="modal-overlay">
      <ModalContainer data-cy="modal" onClick={noop} minWidth={minWidth} data-testid="modal-container">
        <ModalTopRow>
          {onClose && (
            <CloseButton onClick={onClose} data-testid="close-button">
              <CloseText>
                <FormattedMessage id="modal.close" />
              </CloseText>{' '}
              <X size={14} />
            </CloseButton>
          )}
        </ModalTopRow>
        {alert && <ModalContents>{alert}</ModalContents>}
        {title && <ModalHeading>{title}</ModalHeading>}
        {subtitle && <ModalSubtitle>{subtitle}</ModalSubtitle>}
        {children && <ModalContents>{children}</ModalContents>}
        {bottomRow && <ModalBottomRow>{bottomRow}</ModalBottomRow>}
      </ModalContainer>
    </ModalOverlay>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  alert: PropTypes.node,
  onClose: PropTypes.func,
  bottomRow: PropTypes.node,
  children: PropTypes.node,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  className: PropTypes.string,
  minWidth: PropTypes.string
};

export default Modal;
